import { confirmPasswordReset, sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { toast } from 'react-toastify';

import { auth } from '../../config/firebase';
import * as userConstants from '../constants/userConstants';

// login action
const loginAction = (data) => async (dispatch) => {
    try {
        const email = data.email;
        const password = data.password;
        dispatch({ type: userConstants.USER_LOGIN_REQUEST });
        signInWithEmailAndPassword(auth, email, password)
            .then(async (cred) => {
                dispatch({
                    type: userConstants.USER_LOGIN_SUCCESS,
                    payload: cred.user,
                });
            })
            .catch(async (error) => {
                dispatch({
                    type: userConstants.USER_LOGIN_FAIL,
                    payload: error.message,
                });
            });
    } catch (error) {
        dispatch({
            type: userConstants.USER_LOGIN_FAIL,
            payload: error.message,
        });
    }
};

// logout action
const logoutAction = () => async (dispatch) => {
    await signOut(auth);
    dispatch({ type: userConstants.USER_LOGOUT });
    dispatch({ type: userConstants.USER_LOGIN_RESET });
    localStorage.removeItem("userInfo");
    return null;
};

const forgotPasswordLink = (email, setIsLoading) => async (dispatch) => {
    try {
        await sendPasswordResetEmail(auth, email);
        toast.success("Email was sent");
        setIsLoading(false);
    } catch (error) {
        toast.error("Could not send reset password");
        setIsLoading(false);
    }
};

const confirmPasswordResetAction = (
    code,
    newPassword,
    navigate,
    setIsLoading
) => async (dispatch) => {
    try {
        await confirmPasswordReset(auth, code, newPassword);
        toast.success("Password reset successfully");
        setIsLoading(false);
        navigate("/login");
    } catch (error) {
        toast.error("Could not reset password");
        setIsLoading(false);
    }
};

export {
    loginAction,
    logoutAction,
    forgotPasswordLink,
    confirmPasswordResetAction,
};
